import { LegalPage } from "../../components/LegalPage";

export function ResponsibleDisclosure() {
  return (
    <LegalPage
      title="Responsible disclosure"
      description="WeConsult Rx security researcher policy. Scope, safe harbor, reporting channel, and recognition program."
      path="/responsible-disclosure"
      effective="2026-05-30"
    >
      <p>
        Security research helps keep our customers safe. We welcome good-faith
        reports of vulnerabilities and will not pursue legal action against
        researchers who follow this policy.
      </p>

      <h2>Scope</h2>
      <ul>
        <li><code>weconsultrx.com</code> — marketing surface</li>
        <li><code>app.weconsultrx.com</code> — authenticated application</li>
        <li><code>status.weconsultrx.com</code> — status portal</li>
      </ul>

      <h2>Out of scope</h2>
      <ul>
        <li>Vulnerabilities in third-party SaaS we use (report to the vendor).</li>
        <li>Reports based on automated scanner output without reproduction steps.</li>
        <li>Spam, denial-of-service, social engineering of staff.</li>
        <li>Physical attacks against staff facilities.</li>
        <li>Best-practice notices without exploitability (e.g. missing security headers on static assets that contain no sensitive data).</li>
      </ul>

      <h2>Safe harbor</h2>
      <p>
        If you make a good-faith effort to comply with this policy, we will:
      </p>
      <ul>
        <li>Consider your research authorized.</li>
        <li>Not pursue or support any legal action related to it.</li>
        <li>Work with you to understand and resolve the issue quickly.</li>
      </ul>

      <h2>Rules of engagement</h2>
      <ul>
        <li>Test only against accounts you own or have explicit permission to test.</li>
        <li>Do not access, modify, or exfiltrate data belonging to others.</li>
        <li>Do not perform attacks that degrade availability (rate-limit testing OK at low volume).</li>
        <li>Do not publish vulnerabilities prior to coordinated disclosure.</li>
      </ul>

      <h2>How to report</h2>
      <p>
        Email <strong>security@weconsultrx.com</strong>. Include:
      </p>
      <ul>
        <li>A description of the vulnerability and its impact.</li>
        <li>Step-by-step reproduction.</li>
        <li>Affected URL(s).</li>
        <li>Your name / handle (optional, for credit).</li>
      </ul>
      <p>
        We acknowledge within two business days and aim to remediate critical
        issues within 30 days.
      </p>

      <h2>Recognition</h2>
      <p>
        With your permission we will publicly credit you in our security
        acknowledgments page once the issue is resolved.
      </p>

      <h2>security.txt</h2>
      <p>
        Machine-readable contact: <code>/.well-known/security.txt</code>.
      </p>
    </LegalPage>
  );
}
